import { useMemo } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import { useUserIsAdmin } from "./useUserIsAdmin";

export function useAppAuthState() {
  const [user, isAuthLoading] = useAuthState(auth);
  const { userIsAdmin, loading: isAdminLoading } = useUserIsAdmin(user);

  return useMemo(() => {
    return {
      user: user ?? null,
      isUserAdmin: userIsAdmin,
      isLoggedIn: !!user,
      isAuthLoading: isAuthLoading || isAdminLoading,
    };
  }, [isAuthLoading, userIsAdmin, user, isAdminLoading]);
}
